import type { ConfigureProps } from 'react-instantsearch';
import { Configure } from 'react-instantsearch';

export function AlgoliaConfigure({ ...props }: ConfigureProps) {
  return <Configure {...props} />;
}
